module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/hero-pc_3-32ac307394f5a27601dcf4eecb4a3589.png";